export const CONTACT_ACTIONS_WIDGET_DEFAULT_LIMIT = 3;
